import _ from 'lodash';
import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import {MODALS, selectBooking, selectSelectedKycId} from 'ducks/bookings';
import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {KycVerifyVisaModalForm} from './components';

class KycVerifyVisaModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('kycVerifyVisaForm');
  };

  getExtraActions = () => [
    ...this.props.closeModalExtraActions,
    () => this.props.fetchKycDetails(this.props.data.kycId)
  ];

  render() {
    const {closeModal, data: {form: {submitting}}} = this.props;

    return (
      <Modal show={true} onClose={closeModal} type={Modal.EXTRA_SMALL}>
        <Modal.Header heading="Verify Visa" />
        <Modal.Body>
          <div>
            <KycVerifyVisaModalForm getExtraActions={this.getExtraActions} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="submit"
            onClick={this.submitForm}
            blue={!submitting}
            isLoading={submitting}
            disabled={submitting}>
            Verify Visa
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = state => {
  const kycId = selectSelectedKycId(state);
  const booking = selectBooking(state);
  const bookingId = _.get(booking, 'id');

  return {
    kycId,
    bookingId,
    form: {
      submitting: isSubmitting('kycVerifyVisaForm')(state)
    }
  };
};
const mapDispatchToProps = {submit};

export default withModal(
  MODALS.KYC_VERIFY_VISA,
  mapStateToModalData,
  mapDispatchToProps
)(KycVerifyVisaModal);
